module.exports = __webpack_public_path__ + "media/images/lb/518-a737291b0f51c0320c858efb314a8a34.svg";